import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { digilocker, getWorkflowData,getWorkflowInfo } from "api/formDisplay";
import "./index.scss";
import {  Image } from "lib";

import digilockerimg from "../../../assets/images/path0.svg";
import { setSelectedData } from "redux/formDisplay";
import { setVerificationResponse } from "redux/uploadDocumentReducer";

const Digilocker = (props) => {
  const {
    name,
    setUploaded,
    setFileName,
    setFileSize,
    label,
    userInfo,
    clearFieldError,
    autofill,
  } = props;
  
  const dispatch = useDispatch();
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  let sub_id = decryptedId?.subWfId;
  const primary_workflow_id = decryptedId?.primary_workflow_id;
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const verificationResponses = useSelector((state) => state.uploadDocumentReducer);
  const config = useSelector(( state) => state.configurationReducer?.config);
  const organisation_id = config?.organisation_id;
  var  childWindow;
 
  const digilockerauthentication = async () => {
    let result = await digilocker({sub_id,organisation_id,primary_workflow_id});
    childWindow = window.open(result?.link,'_blank','');
    // window.addEventListener('message', async(event)=>{
    // if(event.data == 'completed'){
    // childWindow?.close()
    // handleClose();
    //  let res = await getWorkflowData(decryptedId.subWfId);
    //     dispatch(
    //         setVerificationResponse({
    //           key: name,
    //           value: res?.digilocker_callback_response,
    //         })
    //       );
    //   autofill?.forEach((item) => {
    //     dispatch(
    //       setSelectedData({
    //         key: [`${item?.destination_field}`],
    //         value: res?.digilocker_callback_response?.result?.validated_data[`${item?.source_field}`],
    //       })
    //     );
    //   });
     
    //   }
    //  })
  };


  

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="capture_container">
      <p>- or -</p>
        <div
           className="file-uploader"

           onClick= {digilockerauthentication}
        >

         Upload with &nbsp;
         <Image imageSrc={digilockerimg} alt="" />
          DigiLocker
        </div>
      </div>
    </>
  );
};

export default Digilocker;
